import React from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import * as forgotPasswordActions from "../../redux/actions/forgotPasswordAction";
import { useSelector, useDispatch } from "react-redux";
import ResetPasswordComponent from "../../components/Login/ResetPasswordComponent";
import PropTypes from "prop-types";

const ResetPassword = (props, context) => {
  const dispatch = useDispatch();
  const forgotPasswordReducer = useSelector((state) => state.forgotPasswordReducer);
  const modalReducer = useSelector((state) => state.modalReducer);

  const modalAction = bindActionCreators(modalActions, dispatch);
  const forgotPasswordAction = bindActionCreators(forgotPasswordActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };
  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const verifyEmailAddress = (email) => {
    forgotPasswordAction.verifyEmailAddress(email);
  }

  const resetIsOtpSend = (isOtpSend) => {
    forgotPasswordAction.resetIsOtpSend(isOtpSend);
  }

  const verifyOtp = (email, otp) => {
    forgotPasswordAction.verifyOtp(email, otp);
  }

  const resetVerifyOtpData = () => {
    forgotPasswordAction.resetVerifyOtpData();
  }

  return (
    <ResetPasswordComponent
      closeRemoveModal={closeRemoveModal}
      context={context}
      {...props}
      openSetModalAction={openSetModal}
      forgotPasswordReducer={forgotPasswordReducer}
      verifyEmailAddress={verifyEmailAddress}
      resetIsOtpSend={resetIsOtpSend}
      verifyOtp={verifyOtp}
      modalReducer={modalReducer}
      resetVerifyOtpData={resetVerifyOtpData}
    />
  );
};
ResetPassword.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ResetPassword;
